export default "__VITE_ASSET__BdECxlO9__";